import { Dispatch, SetStateAction } from 'react';
import { MessageType } from '@common/types';
import { TopicLegalName } from '@components/topic-legal-name';
import useChat from '@hooks/use-chat';
import { cn, shouldUseMaxHight } from '@lib/utils';
import { Trans, useTranslation } from 'react-i18next';

interface IChatLayoutProps {
  children: React.ReactNode;
  addStaticMessage: (messages: string, type: MessageType) => void;
  setQuery: Dispatch<SetStateAction<string>>;
  topicPickerControls?: React.ReactNode;
}

function ChatLayout(props: IChatLayoutProps) {
  const { t } = useTranslation();
  const { topics, selectedTopic } = useChat();
  const currentTopic = topics.find((item) => item.id === selectedTopic);
  const topicLegalTitle = currentTopic
    ? t('common.selected_topic', { topic: currentTopic.legalName })
    : t('common.no_topic_selected');

  return (
    // [hexal]
    <main
      className={cn(
        'p-2 bg-xircle-main text-white rounded-2xl py-4 main-container',
        shouldUseMaxHight() && 'max-h-[1000px] min-h-[300px] sm:max-h-[700px] sm:min-h-[200px]'
      )}
      data-iframe-size=""
    >
      <header className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-4 px-2">
        <section className="flex flex-col justify-start items-start">
          <h3 className="m-0 font-normal text-2xl leading-7 tracking-normal custom-heading">
            <Trans i18nKey="header.title" t={t}>
              <b />
            </Trans>
          </h3>
          <h4 className="m-0 font-normal text-base leading-6 custom-sub-heading">
            {t('header.subtitle')}
          </h4>
        </section>
        <section className="text-xs self-start">
          <TopicLegalName
            title={topicLegalTitle}
            text={currentTopic?.legalName || topicLegalTitle}
          />
          {props.topicPickerControls}
        </section>
      </header>
      {props.children}
    </main>
  );
}

export default ChatLayout;
